"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCaptchaAppErrorCode = exports.isCaptchaError = void 0;
const CaptchaApplicationErrorCode_1 = require("../enums/CaptchaApplicationErrorCode");
const isCaptchaError = (httpError) => {
    var _a;
    if (((_a = httpError === null || httpError === void 0 ? void 0 : httpError.response) === null || _a === void 0 ? void 0 : _a.status) !== 403) {
        return false;
    }
    const errorCode = (0, exports.getCaptchaAppErrorCode)(httpError);
    return !!errorCode && Object.values(CaptchaApplicationErrorCode_1.CaptchaApplicationErrorCode).includes(errorCode);
};
exports.isCaptchaError = isCaptchaError;
const getCaptchaAppErrorCode = (httpError) => { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = httpError === null || httpError === void 0 ? void 0 : httpError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.applicationError) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : null; };
exports.getCaptchaAppErrorCode = getCaptchaAppErrorCode;
//# sourceMappingURL=captchaError.js.map